<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: {
    type: Number,
    default: 0,
  },
  label: {
    type: String,
    default: 'Favoritos',
  },
  interactive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const componentTag = computed(() => (props.interactive ? 'button' : 'div'));
</script>

<template>
  <component
    :is="componentTag"
    class="inline-flex items-center gap-2 rounded-full border border-lais-border bg-white px-3 py-2 text-[12px] font-semibold text-lais-text shadow-lais-card"
    :class="
      interactive
        ? 'transition-colors hover:border-lais-primary hover:bg-lais-primary-50/40'
        : ''
    "
    @click="interactive ? emit('click') : null"
  >
    <span class="i-lucide-heart size-3.5 text-[#d4546a]" aria-hidden="true" />
    <span>{{ label }}</span>
    <span
      class="inline-flex min-w-6 justify-center rounded-full bg-lais-primary-50 px-1.5 py-0.5 text-[11px] text-lais-primary"
    >
      {{ count }}
    </span>
  </component>
</template>
